class ProductLAC {
  constructor() {
    this.section = document.querySelector('[data-section-id]');
    if (!this.section) return;
    
    this.sectionId = this.section.dataset.sectionId;
    this.init();
  }

  init() {
    this.setupImageGallery();
    this.setupQuantityButtons();
    this.setupVariantSelection();
    this.setupSharePopup();
    this.setupCollapsibles();
    this.setupStickyCart();
    this.setupAjaxCart();
  }

  setupImageGallery() {
    const thumbnails = this.section.querySelectorAll('.thumbnail');
    
    if (thumbnails.length === 0) {
      return;
    }
    
    // Build images array from thumbnails
    const images = Array.from(thumbnails).map(thumb => {
      // Get the full-size version by replacing width parameter
      let fullSrc = thumb.src;
      // Replace width=100 with width=1635
      fullSrc = fullSrc.replace(/width=\d+/, 'width=1635');
      
      return {
        src: fullSrc,
        alt: thumb.alt
      };
    });
    
    let currentIndex = 0;
    const mainImage = this.section.querySelector(`#mainImage-${this.sectionId}`);
    const prevBtn = this.section.querySelector(`#prevBtn-${this.sectionId}`);
    const nextBtn = this.section.querySelector(`#nextBtn-${this.sectionId}`);
    const counter = this.section.querySelector(`#imageCounter-${this.sectionId}`);

    if (!mainImage) {
      return;
    }

    const updateImage = (index) => {
      if (!images[index]) return;
      
      mainImage.style.opacity = '0.5';
      
      setTimeout(() => {
        mainImage.src = images[index].src;
        mainImage.alt = images[index].alt;
        mainImage.style.opacity = '1';
        currentIndex = index;
        
        // Update thumbnail borders
        thumbnails.forEach((thumb, i) => {
          if (i === index) {
            thumb.classList.remove('border-gray-300');
            thumb.classList.add('border-pink-400');
          } else {
            thumb.classList.remove('border-pink-400');
            thumb.classList.add('border-gray-300');
          }
        });
        
        if (counter) {
          counter.textContent = `${index + 1}/${images.length}`;
        }
      }, 150);
    };

    // Previous button
    if (prevBtn) {
      prevBtn.addEventListener('click', () => {
        currentIndex = (currentIndex - 1 + images.length) % images.length;
        updateImage(currentIndex);
      });
    }

    // Next button
    if (nextBtn) {
      nextBtn.addEventListener('click', () => {
        currentIndex = (currentIndex + 1) % images.length;
        updateImage(currentIndex);
      });
    }

    // Thumbnail clicks
    thumbnails.forEach((thumb, index) => {
      thumb.addEventListener('click', () => {
        updateImage(index);
      });
    });
    
    // Initialize - set first thumbnail as active
    if (thumbnails.length > 0) {
      thumbnails[0].classList.add('border-pink-400');
    }
  }

  setupQuantityButtons() {
    const quantityInput = this.section.querySelector(`#Quantity-${this.sectionId}`);
    const buttons = this.section.querySelectorAll('.quantity-button');

    if (!quantityInput) return;

    buttons.forEach(button => {
      button.addEventListener('click', () => {
        const action = button.dataset.action;
        const currentValue = parseInt(quantityInput.value) || 1;
        
        if (action === 'decrease' && currentValue > 1) {
          quantityInput.value = currentValue - 1;
        } else if (action === 'increase') {
          quantityInput.value = currentValue + 1;
        }
      });
    });
  }

  setupVariantSelection() {
    const form = this.section.querySelector('.product-form');
    if (!form) return;

    const variantInputs = form.querySelectorAll('input[name^="options"]');
    
    variantInputs.forEach(input => {
      input.addEventListener('change', () => {
        this.updateVariant();
      });
    });
  }

  updateVariant() {
    const form = this.section.querySelector('.product-form');
    const formData = new FormData(form);
    const options = {};
    
    for (let [key, value] of formData.entries()) {
      if (key.startsWith('options[')) {
        const optionName = key.match(/\[(.*?)\]/)[1];
        options[optionName] = value;
      }
    }

    // You can add variant update logic here
    console.log('Selected options:', options);
  }

  setupSharePopup() {
    const shareBtn = this.section.querySelector(`#shareBtn-${this.sectionId}`);
    const sharePopup = this.section.querySelector(`#sharePopup-${this.sectionId}`);
    const copyBtn = this.section.querySelector(`#copyLinkBtn-${this.sectionId}`);

    if (shareBtn && sharePopup) {
      shareBtn.addEventListener('click', (e) => {
        e.preventDefault();
        sharePopup.classList.toggle('active');
      });

      document.addEventListener('click', (e) => {
        if (!shareBtn.contains(e.target) && !sharePopup.contains(e.target)) {
          sharePopup.classList.remove('active');
        }
      });
    }

    if (copyBtn) {
      copyBtn.addEventListener('click', () => {
        navigator.clipboard.writeText(window.location.href).then(() => {
          const originalText = copyBtn.textContent;
          copyBtn.textContent = 'Copied!';
          setTimeout(() => {
            copyBtn.textContent = originalText;
          }, 2000);
        });
      });
    }
  }

  setupCollapsibles() {
    const triggers = this.section.querySelectorAll('.collapsible-trigger');
    
    triggers.forEach(trigger => {
      trigger.addEventListener('click', () => {
        const content = trigger.nextElementSibling;
        const icon = trigger.querySelector('.collapsible-icon');
        const isExpanded = trigger.getAttribute('aria-expanded') === 'true';
        
        content.classList.toggle('hidden');
        icon.classList.toggle('fa-plus');
        icon.classList.toggle('fa-minus');
        trigger.setAttribute('aria-expanded', !isExpanded);
      });
    });
  }

  setupStickyCart() {
    const stickyBtn = this.section.querySelector('.sticky-add-to-cart');
    if (!stickyBtn) return;

    stickyBtn.addEventListener('click', () => {
      const formId = stickyBtn.dataset.formId;
      const form = document.getElementById(formId);
      if (form) {
        form.requestSubmit();
      }
    });
  }

  setupAjaxCart() {
    const form = this.section.querySelector('.product-form');
    if (!form) return;

    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      
      const formData = new FormData(form);
      const submitButton = form.querySelector('[type="submit"]');
      
      try {
        submitButton.disabled = true;
        submitButton.textContent = 'Adding...';
        
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          body: formData
        });
        
        if (response.ok) {
          const data = await response.json();
          
          // Trigger cart drawer/update
          if (window.Shopify && window.Shopify.theme) {
            document.dispatchEvent(new CustomEvent('cart:updated', { detail: data }));
          }
          
          submitButton.textContent = 'Added!';
          setTimeout(() => {
            submitButton.textContent = 'Add to Cart';
            submitButton.disabled = false;
          }, 2000);
        } else {
          throw new Error('Failed to add to cart');
        }
      } catch (error) {
        console.error('Error:', error);
        submitButton.textContent = 'Error - Try Again';
        setTimeout(() => {
          submitButton.textContent = 'Add to Cart';
          submitButton.disabled = false;
        }, 2000);
      }
    });
  }
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => new ProductLAC());
  console.log("js loaded");
} else {
  new ProductLAC();
   console.log("js loaded");
}